import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    className="icon"
    style={{transform: 'scale(1.8)'}}
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="#986612"
      d="M512 198.7c-33 0-59.9-26.9-59.9-59.9v-14.3c0-33 26.9-59.9 59.9-59.9s59.9 26.9 59.9 59.9v14.3c-.1 33-26.9 59.9-59.9 59.9zM512 75c-27.3 0-49.5 22.2-49.5 49.5v14.3c0 27.3 22.2 49.5 49.5 49.5s49.5-22.2 49.5-49.5v-14.3C561.4 97.2 539.2 75 512 75z"
    />
    <path
      fill="#D8962A"
      d="M515.5 289.5h-5.8c-24.2 0-43.9-19.8-43.9-43.9v-71.8c0-24.2 19.8-43.9 43.9-43.9h5.8c24.2 0 43.9 19.8 43.9 43.9v71.8c.1 24.1-19.7 43.9-43.9 43.9z"
    />
    <path
      fill="#F6B13A"
      d="M137.7 584.5a374.9 374.9 0 1 0 749.8 0 374.9 374.9 0 1 0-749.8 0Z"
    />
    <path
      fill="#F35426"
      d="M203.5 584.5a309.1 309.1 0 1 0 618.2 0 309.1 309.1 0 1 0-618.2 0Z"
    />
    <path
      fill="#F4F4F4"
      d="M262.9 584.5a249.7 249.7 0 1 0 499.4 0 249.7 249.7 0 1 0-499.4 0Z"
    />
    <path
      fill="#C9CCC7"
      d="M313.3 584.5h-95.5c-7.6 0-13.9-6.2-13.9-13.9 0-7.6 6.2-13.9 13.9-13.9h95.5c7.6 0 13.9 6.2 13.9 13.9-.1 7.7-6.3 13.9-13.9 13.9zm212.6 190.1V870c0 7.6-6.2 13.9-13.9 13.9-7.6 0-13.9-6.2-13.9-13.9v-95.5c0-7.6 6.2-13.9 13.9-13.9 7.6.1 13.9 6.3 13.9 14zm0-477.3v95.5c0 7.6-6.2 13.9-13.9 13.9-7.6 0-13.9-6.2-13.9-13.9v-95.5c0-7.6 6.2-13.9 13.9-13.9 7.6 0 13.9 6.3 13.9 13.9zM810 584.5h-95.5c-7.6 0-13.9-6.2-13.9-13.9 0-7.6 6.2-13.9 13.9-13.9H810c7.6 0 13.9 6.2 13.9 13.9s-6.2 13.9-13.9 13.9z"
    />
    <path fill="#EC5C3D" d="m484.3 624-128-135.1 179.2 52.8z" />
    <path fill="#2E9DC7" d="m483.9 623.8 178.5 52.4-128.6-135.5z" />
  </svg>
)
export default SvgComponent
